import {createContext} from 'react';

import {TVehicleCreateContext} from '../contexts/TVehicleCreateContext';

export const VehicleCreate = createContext<TVehicleCreateContext>({} as TVehicleCreateContext);
